<script setup lang="ts">
import { computed } from 'vue'
import type { Tone } from '../lib/format'

const props = withDefaults(defineProps<{ tone?: Tone; glyph?: string }>(), { tone: 'info', glyph: '' })

const fallbackGlyph = computed(() => {
  if (props.glyph) return props.glyph
  if (props.tone === 'critical') return '⚠'
  if (props.tone === 'warning') return '!'
  if (props.tone === 'ok') return '✓'
  return 'i'
})
</script>

<template>
  <div class="banner" :class="`tone-${tone}`" role="status">
    <span class="banner-glyph" aria-hidden="true">{{ fallbackGlyph }}</span>
    <div><slot /></div>
  </div>
</template>
